<template>
    <div class="instruction-field var-kommer-detta" v-if="isActive">
        <input type="text" class="form-control" name="instruction" v-model="newInstruction" />
        <button class="btn btn-primary" @click="newValue($event, index, instructions)">Spara</button>
    </div>
    <div class="instruction-field" v-else>
        {{ instruction }}
        <button @click="changeValue($event)">
            <svg><use xlink:href="#icon-pen"></use></svg>
        </button>
    </div>
</template>

<script>
export default {
    props: ['instruction', 'instructions', 'index'],

    data() {
        return {
            isActive: false,
            newInstruction: ''
        };
    },

    mounted: function () {
        this.newInstruction = this.instruction;
    },

    methods: {
        changeValue(event) {
            event.preventDefault();
            this.isActive = !this.isActive;
        },

        newValue(event, index, array) {
            event.preventDefault();
            this.instruction = this.newInstruction;
            this.isActive = !this.isActive;

            this.replaceValue(index, array, this.instruction);
        },

        replaceValue(index, array, newValue) {
            array.splice(index, 1, newValue);
        }
    }
};
</script>
